import CodeAreaList from './pages/ListPage.vue'
import CodeAreaDetail from './pages/FormPage.vue'
import CodeAreaIndex from './pages/IndexPage.vue'

export default [
    {
        path: '/code_area',
        component: CodeAreaIndex,
        redirect: '/code_area/list',
        name: 'code_area',
        children: [
            {
                path: 'list',
                component: CodeAreaList,
                name: 'code_area.list'
            },
            {
                path: 'create',
                component: CodeAreaDetail,
                name: 'code_area.create',
                props: { create: true },
            },
            {
                path: 'edit/:id',
                component: CodeAreaDetail,
                name: 'code_area.edit',
                props: { create: false },
            },
        ],
    },
]